export const sheetContentClasses = 'max-w-3xl p-4';
export const sheetTitleClasses = 'flex items-center gap-2';
// Inset so focus rings on the edge fields aren't clipped by the scroll container.
export const sheetBodyClasses = 'max-h-[75vh] space-y-4 overflow-y-auto p-1';
export const statusTextClasses = 'py-8 text-center text-muted-foreground text-sm';
export const errorTextClasses = 'py-8 text-center text-destructive text-sm';
export const kennitalaFieldClasses = 'max-w-xs';
export const patientBlockClasses = 'flex max-w-xs flex-col gap-1.5 rounded-md border bg-muted/30 p-3';
export const patientNameClasses = 'font-medium text-sm';
export const patientKennitalaClasses = 'text-muted-foreground text-xs';
export const lookupStatusRowClasses = 'flex items-center gap-2 text-muted-foreground text-xs';
export const lookupErrorClasses = 'text-destructive text-xs';
export const lockedPatientErrorClasses = 'max-w-xs text-destructive text-xs';
export const requestEditorTextareaClasses = 'min-h-[160px] font-sans';
export const requestEditorHintClasses = 'text-muted-foreground text-xs';
export const requestEditorActionsClasses = 'flex justify-end gap-2';
export const resolutionNoticeClasses = 'block space-y-1 rounded-md border bg-muted/30 p-3 text-sm [&>span]:block';
